import React, { useEffect } from 'react'
import { profileActions, profileSelectors } from '../redux/profileSlice'
import { userActions, userSelectors } from '../redux/userSlice'
import notification from '../components/Notification/notification'
import { useDispatch, useSelector } from 'react-redux'
import { updateUser } from '../api/profileApi'

const useProfileForm = () => {
    const user = useSelector(userSelectors.userDetails)

    const dispatch = useDispatch()

    const success = useSelector(profileSelectors.success)
    const error = useSelector(profileSelectors.errorMessage)
    const hasError = useSelector(profileSelectors.hasError)
    const isFetching = useSelector(profileSelectors.isFetching)
    const newDetails = useSelector(profileSelectors.newDetails)

    useEffect(() => {
        if (success) {
            //Show success
            dispatch(profileActions.reset())
            //TODO: Refresh user details

            dispatch(
                userActions.updateDetails({
                    userDetails: newDetails,
                })
            )
            notification.destroy()
            notification.success({
                title: 'Success',
                description: 'Details updated successfully',
            })
        }

        if (hasError) {
            //Show error and try again
            dispatch(profileActions.reset())
            notification.destroy()
            notification.failure({
                title: 'Something went wrong',
                description: error,
            })
        }
    }, [success, error, hasError, isFetching])

    return (values, dp) => {
        notification.loading({
            title: 'Updating details',
        })

        dispatch(updateUser({ ...user, ...values, profilepicture: dp }))
    }
}

export default useProfileForm
